import {getMasterService} from '../services'

export const getUTCDate = (value) => {
  return new Date(
    Date.UTC(
      value.getUTCFullYear(),
      value.getUTCMonth(),
      value.getUTCDate(),
      value.getUTCHours(),
      value.getUTCMinutes(),
      value.getUTCSeconds(),
    ),
  )
}

export const fetchData = async ({fetchFunction, timeout = 2000, params = ''}) => {
  if (params === undefined) {
    params = null
  }
  try {
    await new Promise((resolve) => setTimeout(resolve, timeout))
    const response = await fetchFunction(params)

    if (response.data && response.data.data) {
      return response.data.data
    } else {
      throw new Error('Respuesta de API incorrecta') // Otra acción en caso de respuesta incorrecta
    }
  } catch (error) {
    console.error('Error al obtener los datos:', error)
    return null // Otra acción o valor predeterminado en caso de error
  }
}

export const getTypeDocument = async () => {
  try {
    const response = await getMasterService({
      pageNumber: 1,
      size: 100,
      tableName: 'TipoDocumento',
    })
    const data = response.data.data
    const filterData = data.filter(
      (item) => item.codigo !== '12' && item.codigo !== '11' && item.codigo !== '06',
    )
    const mappedMaster = filterData.map((master) => ({
      value: master.codigo,
      label: master.nombreCorto,
      length: master.campoadicionaltxt1,
      length2: master.campoadicionaltxt5,
    }))
    return mappedMaster
  } catch (error) {
    console.error('Error al obtener la lista de tipo de documento:', error)
  }
}
